import React, { useState, useEffect, useCallback } from "react";

import { serverURL,postData,getData} from "../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// STAFF MANAGEMENT TABLE - FULLY DYNAMIC
// ─────────────────────────────────────────────────────────────────────────────

const StaffTable = ({ isDark = true }) => {
  const theme = isDark ? 'dark' : 'light';
  
  const colors = {
    background: isDark ? "#0d1117" : "#f9fafb",
    surface: isDark ? "#141824" : "#ffffff",
    surfaceHover: isDark ? "rgba(255,255,255,0.025)" : "rgba(0,0,0,0.02)",
    surfaceLighter: isDark ? "#1a2035" : "#f3f4f6",
    border: isDark ? "#1e2740" : "#e5e7eb",
    borderLight: isDark ? "#1a2035" : "#f3f4f6",
    textPrimary: isDark ? "#f1f5f9" : "#111827",
    textSecondary: isDark ? "#94a3b8" : "#6b7280",
    textMuted: isDark ? "#64748b" : "#9ca3af",
    inputBg: isDark ? "#0f1520" : "#f9fafb",
    inputBorder: isDark ? "#1e2740" : "#e5e7eb",
    selectedBg: isDark ? "rgba(59,130,246,0.07)" : "rgba(79,70,229,0.05)",
    buttonPrimaryBg: isDark ? "#1e3a8a" : "#eef2ff",
    buttonPrimaryColor: isDark ? "#93c5fd" : "#4f46e5",
    modalBg: isDark ? "#141824" : "#ffffff",
    modalBorder: isDark ? "#1e2740" : "#e5e7eb",
    deleteBg: isDark ? "rgba(239,68,68,0.15)" : "#fef2f2",
    deleteColor: "#ef4444",
    addBtnBg: "#4a6cf7",
    exportBtnBg: "#28a745",
    editBtnBg: isDark ? "rgba(59,130,246,0.2)" : "#eef2ff",
    editBtnColor: "#3b82f6",
    viewBtnBg: isDark ? "rgba(139,92,246,0.2)" : "#f3e8ff",
    viewBtnColor: "#8b5cf6",
    statusActiveBg: isDark ? "rgba(34,197,94,0.15)" : "#e8f5e9",
    statusActiveColor: "#22c55e",
    statusInactiveBg: isDark ? "rgba(148,163,184,0.12)" : "#f3f4f6",
    statusInactiveColor: "#94a3b8",
    tableHeaderBg: isDark ? "#0f1520" : "#f9fafb",
    tableRowBorder: isDark ? "#1a2035" : "#f3f4f6",
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [staff, setStaff] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedAdmin, setSelectedAdmin] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [toast, setToast] = useState(null);
  
  // Modal states
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "",
    adminAccess: "No",
    status: "Active"
  });
  const [roles, setRoles] = useState([
    "Super Admin",
    "Manager",
    "Sales",
    "Support",
    "Neeraj"
  ]);

  // ─────────────────────────────────────────────────────────────────────────────
  // API FUNCTIONS
  // ─────────────────────────────────────────────────────────────────────────────
  const fetchStaff = useCallback(async () => {
    setLoading(true);
    try {
      // Try to get from API
      const response = await getData("staff");
      console.log("Staff API Response:", response);
      
      if (response && response.status === true && response.data) {
        setStaff(response.data);
        setFilteredStaff(response.data);
      } else if (Array.isArray(response)) {
        setStaff(response);
        setFilteredStaff(response);
      } else {
        // Fallback mock data based on your image
        const mockStaff = [
          { id: 1, name: "Rohit Gurjar", email: "rohit@gmail.com", phone: "7089211599", role: "Neeraj", adminAccess: "No", status: "Active", createdAt: "2024-01-15" },
          { id: 2, name: "Yash Suri", email: "yash18suri20@gmail.com", phone: "9200018690", role: "Super Admin", adminAccess: "Admin", status: "Active", createdAt: "2024-01-10" },
          { id: 3, name: "Dujesh Khot", email: "dujeshazptodoor@gmail.com", phone: "93019821212", role: "Sales", adminAccess: "No", status: "Active", createdAt: "2024-01-20" },
          { id: 4, name: "Ashishika Suri", email: "ashishikazaptodoor@gmail.com", phone: "8370083222", role: "Super Admin", adminAccess: "No", status: "Active", createdAt: "2024-01-18" },
          { id: 5, name: "Neeraj Verma", email: "nv912333@gmail.com", phone: "9109747086", role: "Neeraj", adminAccess: "No", status: "Active", createdAt: "2024-01-22" },
          { id: 6, name: "Dujesh Khot", email: "dujeshkhot60@gmail.com", phone: "9301982121", role: "Sales", adminAccess: "No", status: "Active", createdAt: "2024-01-25" },
          { id: 7, name: "Yash Raj Suri", email: "admin@zaptodoor.com", phone: "9300018690", role: "Super Admin", adminAccess: "Admin", status: "Active", createdAt: "2024-01-05" },
          { id: 8, name: "Shiva", email: "admin@zaptodoor.com", phone: "7781947165", role: "Manager", adminAccess: "Admin", status: "Active", createdAt: "2024-01-28" },
        ];
        setStaff(mockStaff);
        setFilteredStaff(mockStaff);
      }
    } catch (error) {
      console.error("Fetch staff error:", error);
      showToast("Failed to load staff data", "error");
      // Fallback mock data
      const mockStaff = [
        { id: 1, name: "Rohit Gurjar", email: "rohit@gmail.com", phone: "7089211599", role: "Neeraj", adminAccess: "No", status: "Active", createdAt: "2024-01-15" },
        { id: 2, name: "Yash Suri", email: "yash18suri20@gmail.com", phone: "9200018690", role: "Super Admin", adminAccess: "Admin", status: "Active", createdAt: "2024-01-10" },
        { id: 3, name: "Dujesh Khot", email: "dujeshazptodoor@gmail.com", phone: "93019821212", role: "Sales", adminAccess: "No", status: "Active", createdAt: "2024-01-20" },
        { id: 4, name: "Ashishika Suri", email: "ashishikazaptodoor@gmail.com", phone: "8370083222", role: "Super Admin", adminAccess: "No", status: "Active", createdAt: "2024-01-18" },
        { id: 5, name: "Neeraj Verma", email: "nv912333@gmail.com", phone: "9109747086", role: "Neeraj", adminAccess: "No", status: "Active", createdAt: "2024-01-22" },
        { id: 6, name: "Dujesh Khot", email: "dujeshkhot60@gmail.com", phone: "9301982121", role: "Sales", adminAccess: "No", status: "Active", createdAt: "2024-01-25" },
        { id: 7, name: "Yash Raj Suri", email: "admin@zaptodoor.com", phone: "9300018690", role: "Super Admin", adminAccess: "Admin", status: "Active", createdAt: "2024-01-05" },
        { id: 8, name: "Shiva", email: "admin@zaptodoor.com", phone: "7781947165", role: "Manager", adminAccess: "Admin", status: "Active", createdAt: "2024-01-28" },
      ];
      setStaff(mockStaff);
      setFilteredStaff(mockStaff);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStaff();
  }, [fetchStaff]);

  // Filter staff based on search and filters
  useEffect(() => {
    let filtered = [...staff];
    
    // Search filter
    if (searchTerm) {
      filtered = filtered.filter(s => 
        s.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        s.phone?.includes(searchTerm)
      );
    }
    
    // Role filter
    if (selectedRole !== "all") {
      filtered = filtered.filter(s => s.role === selectedRole);
    }
    
    // Status filter
    if (selectedStatus !== "all") {
      filtered = filtered.filter(s => s.status === selectedStatus);
    }
    
    // Admin access filter
    if (selectedAdmin !== "all") {
      filtered = filtered.filter(s => s.adminAccess === selectedAdmin);
    }
    
    setFilteredStaff(filtered);
    setCurrentPage(1);
  }, [searchTerm, selectedRole, selectedStatus, selectedAdmin, staff]);

  // ─────────────────────────────────────────────────────────────────────────────
  // CRUD OPERATIONS
  // ─────────────────────────────────────────────────────────────────────────────
  const addStaff = async () => {
    // Validation
    if (!formData.name || !formData.email || !formData.phone || !formData.role) {
      showToast("Please fill all required fields", "error");
      return;
    }
    
    setActionLoading(true);
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password || "default123",
        role: formData.role,
        adminAccess: formData.adminAccess,
        status: formData.status
      };
      
      const response = await postData("staff/add", payload);
      
      if (response && response.status === true) {
        showToast("Staff added successfully");
        setShowAddModal(false);
        resetForm();
        fetchStaff();
      } else {
        // Mock add for demo
        const newStaff = {
          id: staff.length + 1,
          ...payload,
          createdAt: new Date().toISOString().split('T')[0]
        };
        setStaff([...staff, newStaff]);
        showToast("Staff added successfully (Demo)");
        setShowAddModal(false);
        resetForm();
      }
    } catch (error) {
      console.error("Add staff error:", error);
      showToast(`Failed to add staff: ${error.message}`, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const updateStaff = async () => {
    if (!formData.name || !formData.email || !formData.phone || !formData.role) {
      showToast("Please fill all required fields", "error");
      return;
    }
    
    setActionLoading(true);
    // try {
    //   const payload = {
    //     name: formData.name,
    //     email: formData.email,
    //     phone: formData.phone,
    //     role: formData.role,
    //     adminAccess: formData.adminAccess,
    //     status: formData.status
    //   };
      
    //   const response = await putData(`staff/update/${selectedStaff.id}`, payload);
      
    //   if (response && response.status === true) {
    //     showToast("Staff updated successfully");
    //     setShowEditModal(false);
    //     resetForm();
    //     fetchStaff();
    //   } else {
    //     // Mock update for demo
    //     const updatedStaff = staff.map(s => 
    //       s.id === selectedStaff.id ? { ...s, ...payload } : s
    //     );
    //     setStaff(updatedStaff);
    //     showToast("Staff updated successfully (Demo)");
    //     setShowEditModal(false);
    //     resetForm();
    //   }
    // } catch (error) {
    //   console.error("Update staff error:", error);
    //   showToast(`Failed to update staff: ${error.message}`, "error");
    // } finally {
    //   setActionLoading(false);
    // }
  };

//   const deleteStaff = async () => {
//     setActionLoading(true);
//     try {
//       const response = await deleteData(`staff/delete/${selectedStaff.id}`);
      
//       if (response && response.status === true) {
//         showToast("Staff deleted successfully");
//         setShowDeleteModal(false);
//         setSelectedStaff(null);
//         fetchStaff();
//       } else {
//         // Mock delete for demo
//         const updatedStaff = staff.filter(s => s.id !== selectedStaff.id);
//         setStaff(updatedStaff);
//         showToast("Staff deleted successfully (Demo)");
//         setShowDeleteModal(false);
//         setSelectedStaff(null);
//       }
//     } catch (error) {
//       console.error("Delete staff error:", error);
//       showToast(`Failed to delete staff: ${error.message}`, "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const toggleStaffStatus = async (staffMember) => {
//     const newStatus = staffMember.status === "Active" ? "Inactive" : "Active";
//     setActionLoading(true);
//     try {
//       const response = await putData(`staff/status/${staffMember.id}`, { status: newStatus });
      
//       if (response && response.status === true) {
//         showToast(`Staff ${newStatus.toLowerCase()}d`);
//         fetchStaff();
//       } else {
//         // Mock update for demo
//         const updatedStaff = staff.map(s => 
//           s.id === staffMember.id ? { ...s, status: newStatus } : s
//         );
//         setStaff(updatedStaff);
//         showToast(`Staff ${newStatus.toLowerCase()}d (Demo)`);
//       }
//     } catch (error) {
//       console.error("Toggle status error:", error);
//       showToast(`Failed to update status: ${error.message}`, "error");
//     } finally {
//       setActionLoading(false);
//     }
//   };

  // ─────────────────────────────────────────────────────────────────────────────
  // UTILITY FUNCTIONS
  // ─────────────────────────────────────────────────────────────────────────────
  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      password: "",
      role: "",
      adminAccess: "No",
      status: "Active"
    });
    setSelectedStaff(null);
  };

  const openEditModal = (staffMember) => {
    setSelectedStaff(staffMember);
    setFormData({
      name: staffMember.name || "",
      email: staffMember.email || "",
      phone: staffMember.phone || "",
      password: "",
      role: staffMember.role || "",
      adminAccess: staffMember.adminAccess || "No",
      status: staffMember.status || "Active"
    });
    setShowEditModal(true);
  };

  const openDeleteModal = (staffMember) => {
    setSelectedStaff(staffMember);
    setShowDeleteModal(true);
  };

  const exportToCSV = () => {
    const headers = ['Name', 'Email', 'Phone', 'Role', 'Admin Access', 'Status', 'Created Date'];
    const csvData = filteredStaff.map(s => [
      s.name,
      s.email,
      s.phone,
      s.role,
      s.adminAccess,
      s.status,
      s.createdAt || new Date().toISOString().split('T')[0]
    ]);
    
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `staff_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showToast("Exported successfully");
  };

  // Pagination
  const totalPages = Math.ceil(filteredStaff.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedStaff = filteredStaff.slice(startIndex, startIndex + itemsPerPage);
  const uniqueRoles = ["all", ...new Set(staff.map(s => s.role).filter(Boolean))];

  // ─────────────────────────────────────────────────────────────────────────────
  // STYLES
  // ─────────────────────────────────────────────────────────────────────────────
  const styles = {
    container: {
      minHeight: "100vh",
      background: colors.background,
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      padding: "20px 24px"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
      flexWrap: "wrap",
      gap: "16px"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700,
      color: colors.textPrimary,
      margin: 0
    },
    titleCount: {
      fontSize: "13px",
      color: colors.textSecondary,
      fontWeight: 500,
      marginLeft: "8px"
    },
    addButton: {
      background: colors.addBtnBg,
      color: "white",
      border: "none",
      padding: "10px 20px",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "13px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      transition: "all 0.2s"
    },
    exportButton: {
      background: colors.exportBtnBg,
      color: "white",
      border: "none",
      padding: "10px 20px",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "13px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      transition: "all 0.2s"
    },
    filtersBar: {
      background: colors.surface,
      border: `1px solid ${colors.border}`,
      borderRadius: "12px",
      padding: "16px 20px",
      marginBottom: "20px",
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
      alignItems: "center"
    },
    searchBox: {
      flex: 1,
      minWidth: "200px",
      position: "relative"
    },
    searchInput: {
      width: "100%",
      padding: "8px 12px 8px 36px",
      background: colors.inputBg,
      border: `1px solid ${colors.inputBorder}`,
      borderRadius: "8px",
      fontSize: "13px",
      color: colors.textPrimary,
      outline: "none",
      transition: "all 0.2s"
    },
    filterGroup: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    },
    filterLabel: {
      fontSize: "12px",
      color: colors.textSecondary,
      fontWeight: 500
    },
    filterSelect: {
      padding: "6px 12px",
      background: colors.inputBg,
      border: `1px solid ${colors.inputBorder}`,
      borderRadius: "6px",
      fontSize: "12px",
      color: colors.textPrimary,
      cursor: "pointer",
      outline: "none"
    },
    tableWrapper: {
      background: colors.surface,
      border: `1px solid ${colors.border}`,
      borderRadius: "12px",
      overflow: "hidden",
      overflowX: "auto"
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "800px"
    },
    th: {
      padding: "14px 12px",
      textAlign: "left",
      fontSize: "11px",
      fontWeight: 700,
      color: "#3b82f6",
      borderBottom: `1px solid ${colors.border}`,
      background: colors.tableHeaderBg,
      textTransform: "uppercase",
      letterSpacing: "0.5px"
    },
    td: {
      padding: "12px",
      borderBottom: `1px solid ${colors.tableRowBorder}`,
      fontSize: "13px",
      color: colors.textPrimary
    },
    statusBadge: (status) => ({
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: "4px 10px",
      borderRadius: "20px",
      fontSize: "11px",
      fontWeight: 600,
      background: status === "Active" ? colors.statusActiveBg : colors.statusInactiveBg,
      color: status === "Active" ? colors.statusActiveColor : colors.statusInactiveColor
    }),
    roleBadge: (role) => ({
      display: "inline-flex",
      padding: "4px 10px",
      borderRadius: "20px",
      fontSize: "11px",
      fontWeight: 600,
      background: colors.surfaceLighter,
      color: colors.textSecondary
    }),
    actionButtons: {
      display: "flex",
      gap: "8px"
    },
    actionBtn: (bg, color) => ({
      padding: "6px 10px",
      borderRadius: "6px",
      background: bg,
      border: "none",
      cursor: "pointer",
      fontSize: "12px",
      color: color,
      transition: "all 0.2s",
      display: "inline-flex",
      alignItems: "center",
      gap: "4px"
    }),
    pagination: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 20px",
      borderTop: `1px solid ${colors.border}`,
      background: colors.tableHeaderBg,
      flexWrap: "wrap",
      gap: "12px"
    },
    modalOverlay: {
      position: "fixed",
      inset: 0,
      zIndex: 1000,
      background: "rgba(0,0,0,0.7)",
      backdropFilter: "blur(4px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    modal: {
      background: colors.modalBg,
      border: `1px solid ${colors.modalBorder}`,
      borderRadius: "16px",
      width: "500px",
      maxWidth: "90vw",
      maxHeight: "85vh",
      overflow: "auto",
      padding: "24px"
    },
    modalTitle: {
      fontSize: "18px",
      fontWeight: 700,
      color: colors.textPrimary,
      marginBottom: "20px"
    },
    formGroup: {
      marginBottom: "16px"
    },
    formLabel: {
      display: "block",
      fontSize: "12px",
      fontWeight: 600,
      color: colors.textSecondary,
      marginBottom: "6px"
    },
    formInput: {
      width: "100%",
      padding: "10px 12px",
      background: colors.inputBg,
      border: `1px solid ${colors.inputBorder}`,
      borderRadius: "8px",
      fontSize: "13px",
      color: colors.textPrimary,
      outline: "none",
      transition: "all 0.2s"
    },
    formSelect: {
      width: "100%",
      padding: "10px 12px",
      background: colors.inputBg,
      border: `1px solid ${colors.inputBorder}`,
      borderRadius: "8px",
      fontSize: "13px",
      color: colors.textPrimary,
      cursor: "pointer",
      outline: "none"
    },
    checkboxGroup: {
      display: "flex",
      gap: "20px",
      alignItems: "center",
      padding: "8px 0"
    },
    checkboxLabel: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "13px",
      color: colors.textPrimary,
      cursor: "pointer"
    },
    modalButtons: {
      display: "flex",
      gap: "12px",
      marginTop: "24px"
    },
    modalButton: (bg, color) => ({
      flex: 1,
      padding: "10px",
      borderRadius: "8px",
      background: bg,
      border: "none",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 600,
      color: color,
      transition: "all 0.2s"
    }),
    toast: {
      position: "fixed",
      bottom: "24px",
      right: "24px",
      zIndex: 1100,
      padding: "12px 20px",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 500,
      animation: "slideUp 0.25s ease"
    }
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        button:hover { opacity: 0.9; transform: translateY(-1px); }
        button:active { transform: translateY(0); }
        input:focus, select:focus { border-color: #3b82f6; box-shadow: 0 0 0 2px rgba(59,130,246,0.1); }
      `}</style>

      {/* Header */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>
            Staff Management
            <span style={styles.titleCount}>({filteredStaff.length})</span>
          </h1>
          <p style={{ fontSize: "12px", color: colors.textMuted, marginTop: "4px" }}>
            Manage your team members and their permissions
          </p>
        </div>
        <div style={{ display: "flex", gap: "12px" }}>
          <button style={styles.exportButton} onClick={exportToCSV}>
            📊 Export CSV
          </button>
          <button style={styles.addButton} onClick={() => setShowAddModal(true)}>
            + Add Staff
          </button>
        </div>
      </div>

      {/* Filters */}
      <div style={styles.filtersBar}>
        <div style={styles.searchBox}>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="🔍 Search by name, email or phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div style={styles.filterGroup}>
          <span style={styles.filterLabel}>Role:</span>
          <select
            style={styles.filterSelect}
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="all">All Roles</option>
            {uniqueRoles.filter(r => r !== "all").map(role => (
              <option key={role} value={role}>{role}</option>
            ))}
          </select>
        </div>
        <div style={styles.filterGroup}>
          <span style={styles.filterLabel}>Admin:</span>
          <select
            style={styles.filterSelect}
            value={selectedAdmin}
            onChange={(e) => setSelectedAdmin(e.target.value)}
          >
            <option value="all">All</option>
            <option value="Admin">Admin Access</option>
            <option value="No">No Access</option>
          </select>
        </div>
        <div style={styles.filterGroup}>
          <span style={styles.filterLabel}>Status:</span>
          <select
            style={styles.filterSelect}
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>

      {/* Staff Table */}
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Phone</th>
              <th style={styles.th}>Role</th>
              <th style={styles.th}>Admin</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              Array.from({ length: 5 }).map((_, i) => (
                <tr key={i}>
                  {Array.from({ length: 8 }).map((_, j) => (
                    <td key={j} style={styles.td}>
                      <div style={{ height: "12px", background: colors.border, borderRadius: "4px", width: j === 0 ? "30px" : "80%" }} />
                    </td>
                  ))}
                </tr>
              ))
            ) : paginatedStaff.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: "center", padding: "60px", color: colors.textMuted }}>
                  No staff members found
                </td>
              </tr>
            ) : (
              paginatedStaff.map((staffMember, idx) => (
                <tr key={staffMember.id}>
                  <td style={styles.td}>{startIndex + idx + 1}</td>
                  <td style={styles.td}>
                    <strong>{staffMember.name}</strong>
                  </td>
                  <td style={styles.td}>{staffMember.email}</td>
                  <td style={styles.td}>{staffMember.phone}</td>
                  <td style={styles.td}>
                    <span style={styles.roleBadge(staffMember.role)}>
                      {staffMember.role}
                    </span>
                  </td>
                  <td style={styles.td}>
                    {staffMember.adminAccess === "Admin" ? (
                      <span style={{ color: colors.editBtnColor, fontWeight: 600 }}>✓ Admin</span>
                    ) : (
                      <span style={{ color: colors.textMuted }}>No</span>
                    )}
                  </td>
                  <td style={styles.td}>
                    {/* <button
                      onClick={() => toggleStaffStatus(staffMember)}
                      style={styles.statusBadge(staffMember.status)}
                    >
                      <div style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: staffMember.status === "Active" ? "#22c55e" : "#94a3b8"
                      }} />
                      {staffMember.status}
                    </button> */}
                  </td>
                  <td style={styles.td}>
                    <div style={styles.actionButtons}>
                      <button
                        onClick={() => openEditModal(staffMember)}
                        style={styles.actionBtn(colors.editBtnBg, colors.editBtnColor)}
                      >
                        ✏️ Edit
                      </button>
                      <button
                        onClick={() => openDeleteModal(staffMember)}
                        style={styles.actionBtn(colors.deleteBg, colors.deleteColor)}
                      >
                        🗑️ Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={styles.pagination}>
            <span style={{ fontSize: "12px", color: colors.textMuted }}>
              Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredStaff.length)} of {filteredStaff.length} entries
            </span>
            <div style={{ display: "flex", gap: "6px" }}>
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: `1px solid ${colors.border}`,
                  background: colors.surface,
                  color: currentPage === 1 ? colors.textMuted : colors.textSecondary,
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "12px"
                }}
              >
                ← Previous
              </button>
              <span style={{
                padding: "6px 12px",
                borderRadius: "6px",
                background: colors.buttonPrimaryBg,
                color: colors.buttonPrimaryColor,
                fontSize: "12px",
                fontWeight: 600
              }}>
                {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                style={{
                  padding: "6px 12px",
                  borderRadius: "6px",
                  border: `1px solid ${colors.border}`,
                  background: colors.surface,
                  color: currentPage === totalPages ? colors.textMuted : colors.textSecondary,
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                  fontSize: "12px"
                }}
              >
                Next →
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Add Staff Modal */}
      {showAddModal && (
        <div style={styles.modalOverlay} onClick={() => setShowAddModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <h2 style={styles.modalTitle}>Add New Staff</h2>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Name *</label>
              <input
                type="text"
                style={styles.formInput}
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder="Enter full name"
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Email *</label>
              <input
                type="email"
                style={styles.formInput}
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="Enter email address"
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Phone *</label>
              <input
                type="tel"
                style={styles.formInput}
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                placeholder="Enter phone number"
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Password</label>
              <input
                type="password"
                style={styles.formInput}
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                placeholder="Enter password (optional)"
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Role *</label>
              <select
                style={styles.formSelect}
                value={formData.role}
                onChange={(e) => setFormData({...formData, role: e.target.value})}
              >
                <option value="">Select Role</option>
                {roles.map(role => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Admin Access</label>
              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="Yes"
                    checked={formData.adminAccess === "Yes"}
                    onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                  /> Yes
                </label>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="No"
                    checked={formData.adminAccess === "No"}
                    onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                  /> No
                </label>
              </div>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Status</label>
              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="Active"
                    checked={formData.status === "Active"}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  /> Active
                </label>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="Inactive"
                    checked={formData.status === "Inactive"}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  /> Inactive
                </label>
              </div>
            </div>
            
            <div style={styles.modalButtons}>
              <button
                style={styles.modalButton(colors.surfaceLighter, colors.textSecondary)}
                onClick={() => setShowAddModal(false)}
              >
                Cancel
              </button>
              <button
                style={styles.modalButton(colors.addBtnBg, "white")}
                onClick={addStaff}
                disabled={actionLoading}
              >
                {actionLoading ? "Adding..." : "+ Add Staff"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Staff Modal */}
      {showEditModal && (
        <div style={styles.modalOverlay} onClick={() => setShowEditModal(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <h2 style={styles.modalTitle}>Edit Staff</h2>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Name *</label>
              <input
                type="text"
                style={styles.formInput}
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Email *</label>
              <input
                type="email"
                style={styles.formInput}
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Phone *</label>
              <input
                type="tel"
                style={styles.formInput}
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Role *</label>
              <select
                style={styles.formSelect}
                value={formData.role}
                onChange={(e) => setFormData({...formData, role: e.target.value})}
              >
                {roles.map(role => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Admin Access</label>
              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="Admin"
                    checked={formData.adminAccess === "Admin"}
                    onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                  /> Admin
                </label>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="No"
                    checked={formData.adminAccess === "No"}
                    onChange={(e) => setFormData({...formData, adminAccess: e.target.value})}
                  /> No
                </label>
              </div>
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Status</label>
              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="Active"
                    checked={formData.status === "Active"}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  /> Active
                </label>
                <label style={styles.checkboxLabel}>
                  <input
                    type="radio"
                    value="Inactive"
                    checked={formData.status === "Inactive"}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  /> Inactive
                </label>
              </div>
            </div>
            
            <div style={styles.modalButtons}>
              <button
                style={styles.modalButton(colors.surfaceLighter, colors.textSecondary)}
                onClick={() => setShowEditModal(false)}
              >
                Cancel
              </button>
              <button
                style={styles.modalButton(colors.editBtnBg, colors.editBtnColor)}
                onClick={updateStaff}
                disabled={actionLoading}
              >
                {actionLoading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedStaff && (
        <div style={styles.modalOverlay} onClick={() => setShowDeleteModal(false)}>
          <div style={{ ...styles.modal, width: "380px" }} onClick={e => e.stopPropagation()}>
            <h2 style={styles.modalTitle}>Confirm Delete</h2>
            <p style={{ fontSize: "13px", color: colors.textSecondary, marginBottom: "20px" }}>
              Are you sure you want to delete <strong>{selectedStaff.name}</strong>? This action cannot be undone.
            </p>
            <div style={styles.modalButtons}>
              <button
                style={styles.modalButton(colors.surfaceLighter, colors.textSecondary)}
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                style={styles.modalButton(colors.deleteBg, colors.deleteColor)}
                // onClick={deleteStaff}
                disabled={actionLoading}
              >
                {actionLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast && (
        <div style={{
          ...styles.toast,
          background: toast.type === "error" ? (isDark ? "#1a0a0a" : "#fef2f2") : (isDark ? "#0a1a0a" : "#f0fdf4"),
          border: `1px solid ${toast.type === "error" ? "rgba(239,68,68,0.4)" : "rgba(34,197,94,0.4)"}`,
          color: toast.type === "error" ? "#ef4444" : "#22c55e"
        }}>
          {toast.message}
        </div>
      )}
    </div>
  );
};

export default StaffTable;